import React, { useRef } from "react";
import { CopyToClipboardTooltip } from "./CopyToClipboardTooltip";
import { PhosphorCopyButton } from "./PhosphorIconButton";
import { InputBase } from "./formInputs/InputBase";

interface CopyToClipboardProps {
  value: string
}

const CopyToClipboard = ({ value }: CopyToClipboardProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const afterCopy = () => {
    setTimeout(() => {
      inputRef.current.focus();
    }, 1);
  }

  return <InputBase
    ref={inputRef}
    value={value}
    onChange={() => {}}
    rightComponent={{
      position: "right",
      type: "action",
      content: <CopyToClipboardTooltip>
        {(copy) => <PhosphorCopyButton layout="none" onClick={() => { copy(value); afterCopy(); }} />}
      </CopyToClipboardTooltip>
    }}
  />
}

export default CopyToClipboard;
